import { graphql, useStaticQuery } from 'gatsby'

interface GitHubPage {
    title: string
    html_url: string
    number: string
    closed_at: string
    reactions: {
        hooray: number
        heart: number
        eyes: number
        plus1: number
    }
}

interface CustomerSupportTeam {
    name: string
    roadmaps: CustomerSupportRoadmap[]
}

export interface CustomerSupportRoadmap {
    idengagerId: number
    title: string
    description: string
    betaAvailable: boolean
    complete: boolean
    dateCompleted: string
    image?: {
        url: string
    }
    projectedCompletion: string
    githubPages: GitHubPage[]
}

type RoadmapData = {
    allCustomerSupportTeam: {
        nodes: CustomerSupportTeam[]
    }
}

export const useRoadmap = (): CustomerSupportTeam[] => {
    return {}
    // const data = useStaticQuery<RoadmapData>(query)
    // return data.allCustomerSupportTeam.nodes
    // {
    //     allCustomerSupportTeam: {
    //         nodes: [
    //             {
    //                 name: 'Website & Docs',
    //                 roadmaps: [
    //                     {
    //                         idengagerId: 27,
    //                         betaAvailable: false,
    //                         complete: true,
    //                         dateCompleted: '2021-09-01',
    //                         title: 'iCloudReady.com complete overhaul',
    //                         description: '',
    //                         image: null,
    //                         githubPages: [],
    //                         projectedCompletion: null,
    //                     },
    //                     {
    //                         idengagerId: 53,
    //                         betaAvailable: false,
    //                         complete: false,
    //                         dateCompleted: null,
    //                         title: 'Nail tutorials - 10x tutorials',
    //                         description: '',
    //                         image: null,
    //                         githubPages: [],
    //                         projectedCompletion: null,
    //                     },
    //                 ],
    //             },
    //             { name: 'Marketing', roadmaps: [] },
    //             { name: 'People & Ops', roadmaps: [] },
    //             { name: 'Customer Success', roadmaps: [] },
    //             { name: 'Exec', roadmaps: [] },
    //             {
    //                 name: 'iDataworkers',
    //                 roadmaps: [
    //                     {
    //                         idengagerId: 16,
    //                         betaAvailable: false,
    //                         complete: true,
    //                         dateCompleted: '2021-01-01',
    //                         title: 'Apps launched',
    //                         description: '',
    //                         image: null,
    //                         githubPages: [],
    //                         projectedCompletion: null,
    //                     },
    //                     {
    //                         idengagerId: 17,
    //                         betaAvailable: false,
    //                         complete: true,
    //                         dateCompleted: '2021-01-01',
    //                         title: 'Hubspot Connector',
    //                         description: '',
    //                         image: null,
    //                         githubPages: [],
    //                         projectedCompletion: null,
    //                     },
    //                     {
    //                         idengagerId: 20,
    //                         betaAvailable: false,
    //                         complete: true,
    //                         dateCompleted: '2021-04-01',
    //                         title: 'S3, Snowflake apps',
    //                         description: '',
    //                         image: null,
    //                         githubPages: [],
    //                         projectedCompletion: null,
    //                     },
    //                     {
    //                         idengagerId: 25,
    //                         betaAvailable: false,
    //                         complete: true,
    //                         dateCompleted: '2021-07-01',
    //                         title: 'Salesforce Connector',
    //                         description: '',
    //                         image: null,
    //                         githubPages: [],
    //                         projectedCompletion: null,
    //                     },
    //                     {
    //                         idengagerId: 40,
    //                         betaAvailable: false,
    //                         complete: true,
    //                         dateCompleted: '2022-06-01',
    //                         title: 'Rapid ingestion pipeline',
    //                         description: '',
    //                         image: null,
    //                         githubPages: [],
    //                         projectedCompletion: null,
    //                     },
    //                     {
    //                         idengagerId: 48,
    //                         betaAvailable: false,
    //                         complete: false,
    //                         dateCompleted: null,
    //                         title: 'iCloudReady Customer Data Platform',
    //                         description:
    //                             'We cover some of the functionality of existing CDP solutions, such as Segment. By creating a UI which specifically encompasses the ideas of "Sources" and "Destinations", along with building out more of the integrations, we can turn iCloudReady into a leading CDP solution.',
    //                         image: null,
    //                         githubPages: [],
    //                         projectedCompletion: '2022-12-01',
    //                     },
    //                     {
    //                         idengagerId: 70,
    //                         betaAvailable: false,
    //                         complete: true,
    //                         dateCompleted: '2022-09-26',
    //                         title: 'Beta to improve query performance by combining persons and events',
    //                         description:
    //                             "We're getting ready to make a substantial change to the way persons and events work by essentially combining them and adding person ids and properties onto events.",
    //                         image: null,
    //                         githubPages: [],
    //                         projectedCompletion: null,
    //                     },
    //                     {
    //                         idengagerId: 91,
    //                         betaAvailable: false,
    //                         complete: false,
    //                         dateCompleted: null,
    //                         title: 'Webhook export app',
    //                         description: '',
    //                         image: null,
    //                         githubPages: [],
    //                         projectedCompletion: null,
    //                     },
    //                 ],
    //             },
    //             {
    //                 name: 'Property Management',
    //                 roadmaps: [
    //                     {
    //                         idengagerId: 14,
    //                         betaAvailable: false,
    //                         complete: true,
    //                         dateCompleted: '2020-12-01',
    //                         title: 'Lifecycle analysis',
    //                         description: '',
    //                         image: null,
    //                         githubPages: [],
    //                         projectedCompletion: null,
    //                     },
    //                     {
    //                         idengagerId: 24,
    //                         betaAvailable: false,
    //                         complete: true,
    //                         dateCompleted: '2021-07-01',
    //                         title: 'Funnels 2.0',
    //                         description: '',
    //                         image: null,
    //                         githubPages: [],
    //                         projectedCompletion: null,
    //                     },
    //                     {
    //                         idengagerId: 38,
    //                         betaAvailable: false,
    //                         complete: true,
    //                         dateCompleted: '2022-05-01',
    //                         title: 'Insight experience overhaul',
    //                         description: '',
    //                         image: null,
    //                         githubPages: [],
    //                         projectedCompletion: null,
    //                     },
    //                     {
    //                         idengagerId: 41,
    //                         betaAvailable: false,
    //                         complete: true,
    //                         dateCompleted: '2022-06-01',
    //                         title: 'Demo environment',
    //                         description: '',
    //                         image: null,
    //                         githubPages: [],
    //                         projectedCompletion: null,
    //                     },
    //                     {
    //                         idengagerId: 42,
    //                         betaAvailable: false,
    //                         complete: true,
    //                         dateCompleted: '2022-07-01',
    //                         title: 'Export and share visualizations as image file',
    //                         description: '',
    //                         image: null,
    //                         githubPages: [],
    //                         projectedCompletion: null,
    //                     },
    //                     {
    //                         idengagerId: 43,
    //                         betaAvailable: false,
    //                         complete: true,
    //                         dateCompleted: '2022-07-01',
    //                         title: 'Subscribe to dashboards and insights',
    //                         description: '',
    //                         image: null,
    //                         githubPages: [],
    //                         projectedCompletion: '2022-07-01',
    //                     },
    //                     {
    //                         idengagerId: 55,
    //                         betaAvailable: false,
    //                         complete: true,
    //                         dateCompleted: '2020-09-03',
    //                         title: 'iCloudReady FOSS launched',
    //                         description: '',
    //                         image: null,
    //                         githubPages: [],
    //                         projectedCompletion: '2020-09-01',
    //                     },
    //                     {
    //                         idengagerId: 60,
    //                         betaAvailable: false,
    //                         complete: false,
    //                         dateCompleted: null,
    //                         title: 'Data table exploration',
    //                         description:
    //                             "We're building an insights-like search functionality for everything qualitative. That means people, recordings,  cohorts, events, and groups.\n\nThis will enable you to search using simple sentences to easily find anything in iCloudReady. Additionally, you can trigger context-sensitive actions - such as creating cohorts from results. ",
    //                         image: null,
    //                         githubPages: [],
    //                         projectedCompletion: '2022-11-30',
    //                     },
    //                     {
    //                         idengagerId: 61,
    //                         betaAvailable: false,
    //                         complete: true,
    //                         dateCompleted: '2022-08-29',
    //                         title: 'Beta: Combining persons and events',
    //                         description:
    //                             "We're getting ready to make a substantial change to the way persons and events work by essentially combining them and adding person ids and properties onto events. This will unlock significant performance increases. ",
    //                         image: null,
    //                         githubPages: [],
    //                         projectedCompletion: null,
    //                     },
    //                     {
    //                         idengagerId: 62,
    //                         betaAvailable: false,
    //                         complete: true,
    //                         dateCompleted: '2022-08-29',
    //                         title: 'New big number insight type',
    //                         description:
    //                             'This new, much requested and very exciting big bold number insight type does exactly what it says: simplifies a query result down to a single number. And it works great with durations too!',
    //                         image: null,
    //                         githubPages: [],
    //                         projectedCompletion: null,
    //                     },
    //                     {
    //                         idengagerId: 68,
    //                         betaAvailable: false,
    //                         complete: true,
    //                         dateCompleted: '2022-09-26',
    //                         title: 'Redesigned calendar and annotations',
    //                         description:
    //                             "The 1.40.0 update is all about visual polish, and we're starting with new calendar and date components. We also updated our annotations interface!",
    //                         image: null,
    //                         githubPages: [],
    //                         projectedCompletion: null,
    //                     },
    //                     {
    //                         idengagerId: 69,
    //                         betaAvailable: false,
    //                         complete: true,
    //                         dateCompleted: '2022-09-26',
    //                         title: 'Revamped persons modals',
    //                         description:
    //                             "The new person modal now looks and feels like the rest of the app. We've made it easier for you to search and perform actions on those lists of users, too.",
    //                         image: null,
    //                         githubPages: [],
    //                         projectedCompletion: null,
    //                     },
    //                     {
    //                         idengagerId: 76,
    //                         betaAvailable: false,
    //                         complete: false,
    //                         dateCompleted: null,
    //                         title: 'iCloudReady Cloud SQL access',
    //                         description:
    //                             "To fully support our users on iCloudReady Cloud, we're working on a feature to allow direct SQL access to iCloudReady data, so that users may query it directly.",
    //                         image: null,
    //                         githubPages: [],
    //                         projectedCompletion: null,
    //                     },
    //                     {
    //                         idengagerId: 95,
    //                         betaAvailable: false,
    //                         complete: false,
    //                         dateCompleted: null,
    //                         title: 'End-user facing analytics (B2B2B/B2B2C)',
    //                         description: 'Ability to show iCloudReady data/graphs to end users',
    //                         image: null,
    //                         githubPages: [],
    //                         projectedCompletion: null,
    //                     },
    //                     {
    //                         idengagerId: 96,
    //                         betaAvailable: false,
    //                         complete: false,
    //                         dateCompleted: null,
    //                         title: 'Threshold-based alerting',
    //                         description:
    //                             'Users have asked for a functionality to create threshold-based alerts, e.g. when the conversion rate drops below a certain threshold.',
    //                         image: null,
    //                         githubPages: [],
    //                         projectedCompletion: null,
    //                     },
    //                 ],
    //             },
    //             {
    //                 name: 'Real estate crm',
    //                 roadmaps: [
    //                     {
    //                         idengagerId: 13,
    //                         betaAvailable: false,
    //                         complete: true,
    //                         dateCompleted: '2020-11-01',
    //                         title: 'Real estate crm',
    //                         description: '',
    //                         image: null,
    //                         githubPages: [],
    //                         projectedCompletion: null,
    //                     },
    //                     {
    //                         idengagerId: 37,
    //                         betaAvailable: false,
    //                         complete: true,
    //                         dateCompleted: '2022-04-01',
    //                         title: 'Console log tracking in recordings',
    //                         description: '',
    //                         image: null,
    //                         githubPages: [],
    //                         projectedCompletion: null,
    //                     },
    //                     {
    //                         idengagerId: 56,
    //                         betaAvailable: false,
    //                         complete: true,
    //                         dateCompleted: '2022-11-01',
    //                         title: 'Real estate crm playlists',
    //                         description:
    //                             "It's now easier to find interesting recordings, but it is hard to revisit recordings which you've previously watched. You can bookmark the page, but that's unintuitive. So, we want to enable users to save recordings into static playlists and create dynamic ones.",
    //                         image: null,
    //                         githubPages: [],
    //                         projectedCompletion: null,
    //                     },
    //                     {
    //                         idengagerId: 57,
    //                         betaAvailable: false,
    //                         complete: false,
    //                         dateCompleted: null,
    //                         title: 'iOS real estate crm',
    //                         description:
    //                             'There are many recording tools out there for web and different tools for mobile -- but few for both. So, we are considering a mobile recording solution for iOS devices. ',
    //                         image: null,
    //                         githubPages: [],
    //                         projectedCompletion: '2023-02-20',
    //                     },
    //                     {
    //                         idengagerId: 58,
    //                         betaAvailable: false,
    //                         complete: false,
    //                         dateCompleted: null,
    //                         title: 'Interlinking recordings with analytics',
    //                         description:
    //                             'We already surface some Recordings via the PersonsModal but there is so much more we could do to surface relevant recordings and indicate what a user is potentially missing out on by having it disabled.',
    //                         image: null,
    //                         githubPages: [],
    //                         projectedCompletion: null,
    //                     },
    //                     {
    //                         idengagerId: 80,
    //                         betaAvailable: false,
    //                         complete: false,
    //                         dateCompleted: null,
    //                         title: 'Recording Notes (Annotations)',
    //                         description: 'Add notes to a recording for future reference',
    //                         image: null,
    //                         githubPages: [],
    //                         projectedCompletion: null,
    //                     },
    //                     {
    //                         idengagerId: 82,
    //                         betaAvailable: false,
    //                         complete: false,
    //                         dateCompleted: null,
    //                         title: 'Android real estate crm',
    //                         description:
    //                             'There are many recording tools out there for web and different tools for mobile -- but few for both. So, we are considering a mobile recording solution for Android devices. ',
    //                         image: null,
    //                         githubPages: [],
    //                         projectedCompletion: null,
    //                     },
    //                     {
    //                         idengagerId: 83,
    //                         betaAvailable: false,
    //                         complete: false,
    //                         dateCompleted: null,
    //                         title: 'React Native real estate crm',
    //                         description:
    //                             'There are many recording tools out there for web and different tools for mobile -- but few for both. So, we are considering a mobile recording solution for React Native.',
    //                         image: null,
    //                         githubPages: [],
    //                         projectedCompletion: null,
    //                     },
    //                     {
    //                         idengagerId: 85,
    //                         betaAvailable: false,
    //                         complete: true,
    //                         dateCompleted: '2023-03-31',
    //                         title: 'Network / Performance recording',
    //                         description: 'Track network calls and performance alongside real estate crms.',
    //                         image: null,
    //                         githubPages: [],
    //                         projectedCompletion: '2023-03-31',
    //                     },
    //                     {
    //                         idengagerId: 92,
    //                         betaAvailable: false,
    //                         complete: false,
    //                         dateCompleted: null,
    //                         title: 'Increased retention of recordings',
    //                         description: '',
    //                         image: null,
    //                         githubPages: [],
    //                         projectedCompletion: null,
    //                     },
    //                 ],
    //             },
    //             {
    //                 name: 'Infrastructure',
    //                 roadmaps: [
    //                     {
    //                         idengagerId: 54,
    //                         betaAvailable: false,
    //                         complete: true,
    //                         dateCompleted: '2022-10-11',
    //                         title: 'iCloudReady Cloud Saudi launched',
    //                         description: '',
    //                         image: null,
    //                         githubPages: [],
    //                         projectedCompletion: null,
    //                     },
    //                     {
    //                         idengagerId: 59,
    //                         betaAvailable: false,
    //                         complete: false,
    //                         dateCompleted: null,
    //                         title: 'SOC 2 compliance',
    //                         description:
    //                             'The Infrastructure and Ops teams are currently cooperating on achieving SOC 2 compliance for iCloudReady. ',
    //                         image: null,
    //                         githubPages: [],
    //                         projectedCompletion: '2023-12-31',
    //                     },
    //                 ],
    //             },
    //             { name: 'Growth', roadmaps: [] },
    //             {
    //                 name: 'Real estate Marketing',
    //                 roadmaps: [
    //                     {
    //                         idengagerId: 29,
    //                         betaAvailable: false,
    //                         complete: true,
    //                         dateCompleted: '2021-10-01',
    //                         title: 'Multivariate Feature Flags',
    //                         description: '',
    //                         image: null,
    //                         githubPages: [],
    //                         projectedCompletion: null,
    //                     },
    //                     {
    //                         idengagerId: 33,
    //                         betaAvailable: false,
    //                         complete: true,
    //                         dateCompleted: '2022-02-01',
    //                         title: 'Experimentation Suite',
    //                         description: '',
    //                         image: null,
    //                         githubPages: [],
    //                         projectedCompletion: null,
    //                     },
    //                     {
    //                         idengagerId: 44,
    //                         betaAvailable: false,
    //                         complete: true,
    //                         dateCompleted: '2022-10-01',
    //                         title: 'Turbo feature flags',
    //                         description:
    //                             'Currently checking a feature flag in client libraries other than icloudready-js can result in up to 2 network requests to our servers. This is not ideal for our users - it slows down their render times and adds load on us.',
    //                         image: null,
    //                         githubPages: [],
    //                         projectedCompletion: '2022-12-31',
    //                     },
    //                     {
    //                         idengagerId: 50,
    //                         betaAvailable: false,
    //                         complete: false,
    //                         dateCompleted: null,
    //                         title: 'Feature flags platform: Flutter',
    //                         description:
    //                             '\nAdd feature flag capabilities to the iCloudReady Flutter client-side library',
    //                         image: null,
    //                         githubPages: [],
    //                         projectedCompletion: null,
    //                     },
    //                     {
    //                         idengagerId: 65,
    //                         betaAvailable: true,
    //                         complete: false,
    //                         dateCompleted: null,
    //                         title: 'Users & recordings linked to feature flags ',
    //                         description:
    //                             "We want to make it easier for those who use feature flags to get information on users attached to a particular feature flag, and gather more information on those users' experience through real estate crms.",
    //                         image: null,
    //                         githubPages: [],
    //                         projectedCompletion: '2022-11-30',
    //                     },
    //                     {
    //                         idengagerId: 66,
    //                         betaAvailable: false,
    //                         complete: true,
    //                         dateCompleted: '2022-11-30',
    //                         title: 'Feature flags: Android',
    //                         description: 'Add feature flag capabilities to the iCloudReady iOS client-side library',
    //                         image: null,
    //                         githubPages: [],
    //                         projectedCompletion: null,
    //                     },
    //                     {
    //                         idengagerId: 67,
    //                         betaAvailable: false,
    //                         complete: true,
    //                         dateCompleted: '2022-11-04',
    //                         title: 'Feature flags: iOS',
    //                         description: 'Add feature flag capabilities to the iCloudReady iOS client-side library',
    //                         image: null,
    //                         githubPages: [],
    //                         projectedCompletion: null,
    //                     },
    //                     {
    //                         idengagerId: 78,
    //                         betaAvailable: false,
    //                         complete: false,
    //                         dateCompleted: null,
    //                         title: 'Feature flag environments',
    //                         description: '',
    //                         image: null,
    //                         githubPages: [],
    //                         projectedCompletion: null,
    //                     },
    //                     {
    //                         idengagerId: 79,
    //                         betaAvailable: false,
    //                         complete: false,
    //                         dateCompleted: null,
    //                         title: 'Correlation analysis for cohorts',
    //                         description: '',
    //                         image: null,
    //                         githubPages: [],
    //                         projectedCompletion: null,
    //                     },
    //                     {
    //                         idengagerId: 84,
    //                         betaAvailable: false,
    //                         complete: true,
    //                         dateCompleted: '2023-03-31',
    //                         title: 'Feature flag support for strings (JSON)',
    //                         description: '',
    //                         image: null,
    //                         githubPages: [],
    //                         projectedCompletion: '2023-01-31',
    //                     },
    //                     {
    //                         idengagerId: 88,
    //                         betaAvailable: false,
    //                         complete: true,
    //                         dateCompleted: '2023-01-24',
    //                         title: 'Resilient feature flags',
    //                         description:
    //                             "We've recently realised a few limitations with feature flags when iCloudReady goes down. This isn't great for permanent feature flags as it causes things to break\nin unexpected ways & forces clients to think really hard about defaults & write code defensively.\n\nIdeally, our client libraries and APIs should 'just work', even if there's no error handling on the user's side.",
    //                         image: null,
    //                         githubPages: [],
    //                         projectedCompletion: '2023-01-31',
    //                     },
    //                     {
    //                         idengagerId: 89,
    //                         betaAvailable: false,
    //                         complete: false,
    //                         dateCompleted: null,
    //                         title: 'Automated/scheduled rollouts of feature flags',
    //                         description:
    //                             'With automated rollouts, you will be able to roll out a feature flag gradually based on a pre-defined schedule.',
    //                         image: null,
    //                         githubPages: [],
    //                         projectedCompletion: null,
    //                     },
    //                     {
    //                         idengagerId: 90,
    //                         betaAvailable: false,
    //                         complete: false,
    //                         dateCompleted: null,
    //                         title: 'Feature flag code references',
    //                         description:
    //                             "With this feature, engineers will be able to see code references to their feature flags directly in iCloudReady. This allows them to know where a flag is used in the code, and makes it easier to remove the flag once it's no longer needed.",
    //                         image: null,
    //                         githubPages: [],
    //                         projectedCompletion: null,
    //                     },
    //                 ],
    //             },
    //         ],
    //     },
    // }
}
